export const theme = {
	color: {
		grey: '#d8d8d8',
		red: '#FF0000',
		green: '#00FCAC',
		purple: '#9454FF'
	},
	container: {
		xs: 375,
		sm: 480,
		md: 768,
		lg: 992,
		xl: 1090,
		xxl: 1360
	},
	breakpoints: {
		xxl: 1400,
		xl: 1090,
		lg: 992,
		md: 768,
		sm: 480,
		xs: 375
	}
}